

















import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop, Watch} from 'vue-property-decorator';

@Component({})
export default class RequestStatus extends Vue {
    @Prop({default: false})
    loading!: boolean;

    @Prop({default: 'Loading...'})
    loadingText!: string;

    @Prop({default: null})
    error?: Error | null;

    @Watch('error')
    onError() {
        // TODO: catch
    }
}

